/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendActualCreditDto } from '../../models/backend-actual-credit-dto';
import { BackendPatchedActualCreditRequestDto } from '../../models/backend-patched-actual-credit-request-dto';

export interface MonitoringActualsCreditsPartialUpdate$XWwwFormUrlencoded$Params {
  id: number;
  body?: BackendPatchedActualCreditRequestDto;
}

export function monitoringActualsCreditsPartialUpdate$XWwwFormUrlencoded(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringActualsCreditsPartialUpdate$XWwwFormUrlencoded$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendActualCreditDto>> {
  const rb = new RequestBuilder(rootUrl, monitoringActualsCreditsPartialUpdate$XWwwFormUrlencoded.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/x-www-form-urlencoded');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendActualCreditDto>;
    }),
  );
}

monitoringActualsCreditsPartialUpdate$XWwwFormUrlencoded.PATH = '/api/monitoring/actuals/credits/{id}/';
